import axios from "axios";
import { GamePayload } from "models/GamePayload";
import { buildGameTypeFromGamePayload, GameType } from "models/GameType";
import { getAuthToken } from "utils/auth_helpers";
import { BASE_URL } from "utils/constants";

export const getGame: (gameId: string) => Promise<GameType | null> = (gameId) => {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.post["Content-Type"] = "application/json";
  axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`;

  return axios
    .get(`/api/game/${gameId}`)
    .then((res) => {
      return buildGameTypeFromGamePayload(res.data as GamePayload);
    })
    .catch((err) => {
      console.log("Failure");
      console.log(err);
      return null;
    });
};

export default getGame;
